var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 9.67949L12.0754 10.0192C12.0754 10.0192 11.2632 10.8262 9.04692 8.62274C6.83067 6.41923 7.64292 5.61223 7.64292 5.61223L7.85742 5.39773C8.38767 4.87123 8.43792 4.02523 7.97517 3.40723L7.03017 2.14498C6.45717 1.37998 5.35092 1.27873 4.69467 1.93123L3.51717 3.10123C3.19242 3.42523 2.97492 3.84373 3.00117 4.30873C3.06867 5.49898 3.60717 8.05873 6.61017 11.0452C9.79542 14.2117 12.7842 14.3377 14.0059 14.2237C14.3929 14.1877 14.7289 13.9912 14.9997 13.7212L16.0647 12.6622C16.7847 11.9475 16.5822 10.7212 15.6612 10.221L14.2287 9.44173C13.6242 9.11398 12.8892 9.20999 12.4167 9.67949Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phoneicon.0b6ca61a63a7301450525ae56497230d.svg";
export { ForwardRef as ReactComponent };